import { CommandButton } from '@nest/internal-frontend';
import { Dialog, DialogContent, DialogHeader, DialogTitle, Skeleton, Table, TableBody, TableCell, TableRow } from '@nest/uikit-react';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTerminalClient } from '../client-rpc-router';
import { useCommandStockItemPrintLabels } from './useCommandStockItemPrintLabels.hook';

export function StockItemLinkDetail({ stockItemId, name }: { stockItemId?: number; name?: string }) {
	const client = useTerminalClient();
	const [isOpen, setIsOpen] = useState(false);

	const stockItemQuery = useQuery({
		queryKey: ['stockItem', stockItemId],
		queryFn: () => client.wms.getStockItemByIdQuery.execute({ id: stockItemId! }),
		enabled: (!!stockItemId && !name) || (!!stockItemId && isOpen)
	});

	const command = useCommandStockItemPrintLabels({ id: stockItemId });

	if (name == null && stockItemQuery.isLoading) {
		return <Skeleton className="w-20 h-2" />;
	}

	const stockItem = stockItemQuery.data;

	return (
		<>
			<div onClick={() => setIsOpen(true)}>{name ?? stockItem?.item?.name}</div>
			<Dialog open={isOpen} onOpenChange={setIsOpen}>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>{stockItem?.item?.name}</DialogTitle>
					</DialogHeader>
					{stockItemQuery.isLoading ? (
						<Table>
							<TableBody>
								<TableRow>
									<TableCell className="text-muted-foreground">Název</TableCell>
									<TableCell>
										<Skeleton className="w-40 h-4" />
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className="text-muted-foreground">EAN</TableCell>
									<TableCell>
										<Skeleton className="w-40 h-4" />
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className="text-muted-foreground">Kód</TableCell>
									<TableCell>
										<Skeleton className="w-24 h-4" />
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					) : (
						<>
							<Table>
								<TableBody>
									<TableRow>
										<TableCell className="text-muted-foreground">EAN</TableCell>
										<TableCell>{stockItem?.item?.ean}</TableCell>
									</TableRow>
									<TableRow>
										<TableCell className="text-muted-foreground">Kód</TableCell>
										<TableCell>{stockItem?.item?.code}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
							<div className="flex justify-end">
								<CommandButton command={command} className="w-full" />
							</div>
						</>
					)}
				</DialogContent>
			</Dialog>
		</>
	);
}
